import { ISnotrRoute } from '..';

export default [ {
  path: '/customers',
  name: 'Customers',
  meta: {
    title: 'TabTitle.customers',
    applicationMode: 'InvoicingMode',
  },
  component: () => import('@/pages/customers.vue'),
} ] as ISnotrRoute[];
